type FormLoadingProps = {
  loading: boolean;
};

const FormLoading = ({ loading }: FormLoadingProps) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="flex flex-col items-center gap-4">
        <span className="w-16 h-16 border-4 border-[#046DB3] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#046DB3] font-semibold text-xl">
          Đang tải...
        </p>
      </div>
    </div>
  );
};

export default FormLoading;
